var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 3.21873C14.075 3.51248 14.075 3.98748 13.7812 4.2781L5.53123 12.5312C5.23748 12.825 4.76248 12.825 4.47185 12.5312L0.218726 8.28123C-0.0750244 7.98748 -0.0750244 7.51248 0.218726 7.22185C0.512476 6.93123 0.987476 6.9281 1.2781 7.22185L4.99685 10.9406L12.7187 3.21873C13.0125 2.92498 13.4875 2.92498 13.7781 3.21873H13.7812Z",
    fill: "#33912E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })))));
};
export default SvgCheckMark;